/**
 * Generated Avatar Sprite Assets
 * 
 * All sprites generated via image-to-image anchoring from reference JJQs0.jpg
 * Base uniform color is GREEN - palette swap will recolor to user's chosen colors
 */

export const SPRITE_ASSETS = {
  // Male base bodies by skin tone (v2 - isolated sprites)
  male: {
    light: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/34b2b50bb9724fdb43be7a0739210511c6af97a757f187906e108395aec48c21.jpeg",
    medium: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/1d9e83f04913f53a69a19641c07cf0c6f6c830b96ffc1d49bfa87bae56f173c0.jpeg",
    tan: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/b115c4f937d22d6576cdf3cccf256778151607395d42b5fd8b8df496b0870eb5.jpeg",
    brown: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/aaa339cae3978bee36d2b182bdf7c1af869a63fd3a9e6478a023accee62d8d9f.jpeg",
    dark: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/1dbf9718311c831de14072d1f6cb6d0ec58a7008816e06a8d76199a219cfcf56.jpeg",
  },
  
  // Female base bodies by skin tone (v3 - no mustaches)
  female: {
    light: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/e69ad8c3e0eefd4c0ef2d5d941dd9a4b259a9ad9cc4b8a295db89931aa99a63a.jpeg",
    medium: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/b05893b0b3995ebffbf41eccdf373b6df155ae94d4b9d3347b5b6dee3f2e818e.jpeg",
    tan: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/c36dc3f53969b56824504985fca066c761da2a25f5659cd63a14145d39110b6c.jpeg",
    brown: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/78015533d80dabdcd577e7b01d6d4aa234e66d049d889c7c7722fbcf0f63b5db.jpeg",
    dark: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/1878dbf5b06de87f327aa3933630115a5b1440bfd7c682dd5359f5392f395bb2.jpeg",
  },
  
  // Flair items (isolated overlay sprites with transparent backgrounds)
  flair: {
    sunglasses: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/bba73567c25211d6db86e99b9a9e78517f4e91031a54e1cfbf0fa0a1dc296cf1.jpeg",
    gold_chain: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/84d254d99478b23b53efeb75d1cbe905a7d8e11385c8bfd0786a74df2faa0f58.jpeg",
    bat: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/3346dc3a07e05c3142fa5eba2a8ce0c028182f5d80854ad5da9ac60027c8138e.jpeg",
    glove: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/fb8ba390d5ea4d79ac4ef09fb0d4c35b03748ee44d34a2860c4ac2ab67f051cc.jpeg",
    neon_cleats: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/af0803eb50eb6eb61151a87c3c704a5ab44331d4f6f8b3be0209f4d05e501416.jpeg",
  },
  
  // UI Chrome elements
  ui: {
    button_green: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/32fe70fd676e545b57e75ebeaa0afe580341e016694e4ba00dd31d135030c74f.jpeg",
    button_cream: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/8ddbc97e85514c68ca65d14333f839018d8bf0aa2ef6247e2e02de0615f97d73.jpeg",
    tabs: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/b1c5b49e9292dea6c9df333f39f469423ca8c3b93ab73dbfc1d4c98c73cc329b.jpeg",
    panel_frame: "https://static.prod-images.emergentagent.com/jobs/bd06dc8b-54db-49b4-baa9-7a42481875dc/images/ce64135e019a83e6f41e70d4181d67a625453be729076191b81fd777383521ce.jpeg",
  }
};

// Base uniform colors in the generated sprites (GREEN)
// These are the source colors that will be mapped to user's chosen colors
export const SOURCE_UNIFORM_COLORS = {
  // Primary (jersey/cap/socks) - greens
  primary: {
    highlight: { r: 90, g: 160, b: 90 },   // Light green
    base: { r: 60, g: 130, b: 60 },        // Main green
    shadow: { r: 40, g: 100, b: 40 },      // Dark green
    deep: { r: 25, g: 70, b: 25 },         // Deepest green
  },
  // Secondary (pants) - whites/creams
  secondary: {
    highlight: { r: 255, g: 255, b: 255 }, // White
    base: { r: 240, g: 235, b: 220 },      // Cream
    shadow: { r: 200, g: 195, b: 180 },    // Light shadow
    deep: { r: 160, g: 155, b: 140 },      // Deep shadow
  },
  // Accent (trim/piping) - golds
  accent: {
    highlight: { r: 255, g: 230, b: 100 }, // Bright gold
    base: { r: 220, g: 180, b: 50 },       // Gold
    shadow: { r: 180, g: 140, b: 30 },     // Dark gold
  }
};

// Curated uniform color palette (24 colors + Dodger Blue)
export const UNIFORM_COLOR_PALETTE = [
  // Reds
  { name: 'Cardinal Red', hex: '#C41E3A' },
  { name: 'Crimson', hex: '#DC143C' },
  { name: 'Scarlet', hex: '#FF2400' },
  
  // Oranges
  { name: 'Orange', hex: '#FF6600' },
  { name: 'Tangerine', hex: '#FF9966' },
  
  // Yellows/Golds
  { name: 'Gold', hex: '#FFD700' },
  { name: 'Athletic Gold', hex: '#FFCC00' },
  { name: 'Yellow', hex: '#FFFF00' },
  
  // Greens
  { name: 'Grass Green', hex: '#4B8B3B' },
  { name: 'Forest Green', hex: '#228B22' },
  { name: 'Kelly Green', hex: '#4CBB17' },
  { name: 'Teal', hex: '#008080' },
  
  // Blues
  { name: 'Dodger Blue', hex: '#1E90FF' },  // Added per request
  { name: 'Royal Blue', hex: '#4169E1' },
  { name: 'Navy Blue', hex: '#000080' },
  { name: 'Powder Blue', hex: '#B0E0E6' },
  { name: 'Sky Blue', hex: '#87CEEB' },
  
  // Purples
  { name: 'Purple', hex: '#800080' },
  { name: 'Violet', hex: '#8B00FF' },
  
  // Browns
  { name: 'Dirt Brown', hex: '#8B4513' },
  { name: 'Chocolate', hex: '#7B3F00' },
  
  // Neutrals
  { name: 'Black', hex: '#1a1a1a' },
  { name: 'Charcoal', hex: '#36454F' },
  { name: 'Silver', hex: '#C0C0C0' },
  { name: 'White', hex: '#FFFFFF' },
  { name: 'Cream', hex: '#F5F5DC' },
];

// Locked base app palette (do not change)
export const APP_BASE_PALETTE = {
  cream: '#F5F5DC',
  grass: '#4B8B3B',
  dirt: '#8B4513',
  ink: '#1a1a1a',
  scoreboardBg: '#000000',
  scoreboardText: '#00FF00',
};

// Flair item anchor positions (relative to avatar canvas)
// Avatar figure analysis: eyes ~26% from top, neck ~31%, feet ~100%
// Figure is centered horizontally at 50%
// 
// Values: 
//   x = left edge position (percentage of canvas width)
//   y = vertical CENTER point of the flair (percentage of canvas height)
//   width = target width (percentage of canvas width) - height calculated from aspect ratio
export const FLAIR_ANCHORS = {
  male: {
    // Sunglasses: Over eyes - moved down from cap-brim to eye level
    sunglasses: { x: 0.38, y: 0.32, width: 0.18 },
    // Gold chain: At neck/collar - moved down from above shoulders
    gold_chain: { x: 0.32, y: 0.38, width: 0.30 },
    // Bat: Held to the right side of body
    bat: { x: 0.62, y: 0.55, width: 0.25 },
    // Glove: On left hand/side
    glove: { x: 0.12, y: 0.50, width: 0.20 },
    // Neon cleats: At feet level
    neon_cleats: { x: 0.28, y: 0.96, width: 0.40 },
  },
  female: {
    sunglasses: { x: 0.38, y: 0.32, width: 0.18 },
    gold_chain: { x: 0.32, y: 0.38, width: 0.30 },
    bat: { x: 0.62, y: 0.55, width: 0.25 },
    glove: { x: 0.12, y: 0.50, width: 0.20 },
    neon_cleats: { x: 0.28, y: 0.96, width: 0.40 },
  }
};
